import {MultilingualText, toLocalString} from "@/i18n/MultilingualText";
import {AskQuestion} from "@/Core/Interactions";
import {toDictionary} from "@/Utility";

export type Question = IMultipleChoiceQuestion|IOrderQuestion|ICategoryQuestion;

export interface IQuestion {
    questionType: "choice"|"sequence"|"category";
    id: string;
    text: MultilingualText;
    minAnswers: number;
    maxAnswers: number;
    maxAttempts: number;
    feedback: MultilingualText;
}

export interface IMultipleChoiceQuestion extends IQuestion {
    questionType: "choice";
    answers: IMultipleChoiceQuestionAnswer[];
}

export interface IMultipleChoiceQuestionAnswer {
    id: string;
    isCorrect: boolean;
    text: MultilingualText;
    feedback: MultilingualText|null;
}

export interface IOrderQuestion extends IQuestion {
    questionType: "sequence";
    items: IOrderQuestionAnswer[];
    patterns: {codes: string[]}[];
}

export interface IOrderQuestionAnswer {
    id: string;
    text: MultilingualText;
    feedback: MultilingualText|null;
}

export interface ICategoryQuestion extends IQuestion {
    questionType: "category";
    items: ICategoryQuestionAnswer[];
    categories: ICategory[];
}

export interface ICategoryQuestionAnswer {
    id: string;
    text: MultilingualText;
    feedback: MultilingualText|null;
}


export interface ICategory {
    id: string;
    text: MultilingualText;
    items: string[];
}

export function convertToAskQuestion(question: Question): AskQuestion {
    if (question.questionType === "choice") {
        return {
            questionType: "choice",
            questionCode: question.id,
            questionText: toLocalString(question.text),
            maxAttempts: question.maxAttempts,
            minAnswers: question.minAnswers,
            maxAnswers: question.maxAnswers,
            items: toDictionary(question.answers, a => a.id, a => ({
                code: a.id,
                itemText: toLocalString(a.text)
            }))
        };
    }
    else if (question.questionType === "category") {
        return {
            questionType: "category",
            questionCode: question.id,
            questionText: toLocalString(question.text),
            maxAttempts: question.maxAttempts,
            minAnswers: question.minAnswers,
            maxAnswers: question.maxAnswers,
            items: toDictionary(question.items, a => a.id, a => ({
                code: a.id,
                itemText: toLocalString(a.text)
            })),
            categories: toDictionary(question.categories, c => c.id, c => toLocalString(c.text))
        };
    }
    else {
        return {
            questionType: "sequence",
            questionCode: question.id,
            questionText: toLocalString(question.text),
            maxAttempts: question.maxAttempts,
            minAnswers: question.minAnswers,
            maxAnswers: question.maxAnswers,
            items: toDictionary(question.items, a => a.id, a => ({
                code: a.id,
                itemText: toLocalString(a.text)
            }))
        }
    }
}